import { useState, useEffect } from 'react';
import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Capacitor } from '@capacitor/core';
import toast from 'react-hot-toast';

function useMobileUpdate() {
  const [updateState, setUpdateState] = useState<{
    isLoading: boolean;
    requiresUpdate: boolean;
    currentVersion?: string | number;
    availableVersion?: string | number;
    error?: Error;
  }>({
    isLoading: true,
    requiresUpdate: false,
  });

  const checkAppVersion = async () => {
    // Skip version check if running in browser
    if (Capacitor.getPlatform() === 'web') {
      setUpdateState(prev => ({ ...prev, isLoading: false }));
      return;
    }

    try {
      const result = await AppUpdate.getAppUpdateInfo();
      
      const currentVersion = Capacitor.getPlatform() === 'android' 
        ? result.currentVersionCode 
        : result.currentVersionName;
        
      const availableVersion = Capacitor.getPlatform() === 'android' 
        ? result.availableVersionCode 
        : result.availableVersionName;

      const requiresUpdate = currentVersion !== availableVersion;

      setUpdateState({
        isLoading: false,
        requiresUpdate,
        currentVersion,
        availableVersion,
      });

    } catch (error) {
      setUpdateState({
        isLoading: false,
        requiresUpdate: false,
        error: error as Error,
      });
    }
  };

  const openAppStore = async () => {
    try {
      await AppUpdate.openAppStore();
    } catch{
      toast.error('خطأ في فتح التطبيق من المتجر');
    }
  };

  useEffect(() => {
    checkAppVersion();
  }, []);

  return {
    ...updateState,
    checkAppVersion,
    openAppStore,
    isMobile: Capacitor.getPlatform() !== 'web',
  };
}

export default useMobileUpdate;